export type HapticKind = 'selection' | 'light' | 'success' | 'warning';

const patterns: Record<HapticKind, number | number[]> = {
  selection: 5,
  light: 8,
  success: [10, 35, 16],
  warning: [18, 45, 18]
};

export function haptic(kind: HapticKind = 'selection'): void {
  if (!window.matchMedia('(pointer: coarse)').matches) return;
  if (!('vibrate' in navigator)) return;
  navigator.vibrate(patterns[kind]);
}
